<!--
 * @Author: wsx
 * @Date: 2022-01-05 18:45:47
 * @LastEditTime: 2022-01-12 18:03:34
 * @LastEditors: your name
 * @Description:穿梭框应用
-->
<template>
  <el-dialog
    v-model="dialogVisible"
    title="卡口选择"
    width="50%"
    @close="closeDialog"
  >
    <div class="TransferApplication" v-loading="loading">
      <h-transfer
        v-model="transferKeys"
        nodeKey="cameraId"
        checkedKey="cameraId"
        :props="{ value: 'treeId', label: 'name' }"
        :data="treeData"
        :default-expanded-keys="[rootNodeKey]"
        :titles="['待选', '已选']"
        :showDefineTree="true"
      >
      </h-transfer>
    </div>
    <template #footer>
      <span class="dialog-footer">
        <h-button type="primary" @click="emitCheckList">确定</h-button>
        <h-button @click="closeDialog">取消</h-button>
      </span>
    </template>
  </el-dialog>
</template>
<script>
import {
  computed,
  defineComponent,
  onMounted,
  reactive,
  toRefs,
  useSlots,
  watchEffect,
} from "vue";
import { toRaw } from "@vue/reactivity";
import {
  queryOrganPersonList,
  queryOrganListId,
  queryOrganList,
} from "@/api/system";
import {
  queryRealVideoTree,
  queryTreeAreaVideo,
} from "@/api/videoControl/videoApi.js";
import { getMenutree } from "@/api/system/region.js";
import util from "@util/js";
export default defineComponent({
  name: "TransferApplication",
  components: {},
  props: {
    icon: {
      type: String,
    },
    elIcon: {
      type: String,
    },
    fontSize: {
      type: String,
      default: "16px",
    },
    // 展示弹窗
    visible: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, context) {
    const data = reactive({
      loading: false,
      dialogVisible: false,
      transferKeys: [],
      treeOrganPerson: [],
      rootNodeKey: "",
      videoData: null,
      treeData: [],
      organMap: {},
    });
    const refData = toRefs(data);
    //使用wache监听不报红
    watchEffect(() => {
      data.dialogVisible = props.visible;
    });

    //获取区域树数据
    const queryOrganPersonListAsycn = async () => {
      // let param = {
      //   deptId: 5
      // };
      const result = await getMenutree();
      // result.deptList.forEach((item) => {
      //   item.treeId = item.deptId;
      //   const children = item.userList || [];
      //   Reflect.deleteProperty(item, "userList");
      //   children.forEach((p) => {
      //     p.treeId = "person-" + p.userId;
      //   });
      //   item.children = children;
      // });
      // const options = { pid: "parentId", id: "deptId", rootPid: 4 };
      // const treeData = util.arrayToTree(result.deptList, options);
      const treeData = [result.data];
      data.treeOrganPerson = treeData;
      // data.treeData = treeData;
      queryRealVideoTreeAsync();
    };
    // 获取区域树中所有摄像头数据
    const queryRealVideoTreeAsync = async () => {
      data.loading = true;
      // const res = await queryRealVideoTree();
      // const params = {
      //   areaId: value.id,
      // };
      const res = await queryTreeAreaVideo();
      data.videoData = res;
      let arrayGroup = arrayGroupBy(data.videoData.cameraBaseDtls, "areaId");
      let changeArrayGroup = {};
      arrayGroup.forEach((item) => {
        item.forEach((it) => {
          it.name = it.cameraName;
          it.treeId = "device_" + it.deviceId;
        });
        changeArrayGroup[item[0].areaId] = item;
      });
      let changeArrayGroupArray = Object.keys(changeArrayGroup);
      const getChildren = (obj) => {
        for (let key in obj) {
          if (key == "children") {
            obj[key].forEach((item) => {
              getChildren(item);
              // let status = item.children.length == 0;
              // if (status) {
              //   console.log(changeArrayGroup[item.id]);
              //   changeArrayGroup[item.id].forEach((it) => {
              //     console.log(it);
              //   });
              // }
              if (changeArrayGroupArray.includes(item.id + ""))
                changeArrayGroup[item.id].forEach((it) => {
                  item.children.push(it);
                });
              // item.children.push(changeArrayGroup[item.id]);
            });
          }
        }
      };

      getChildren(data.treeOrganPerson[0]);
      data.treeData = data.treeOrganPerson;
      console.log(data.treeData);
      data.loading = false;
    };
    const emitCheckList = () => {
      context.emit("transferApplicationList", data.transferKeys);
    };
    const arrayGroupBy = (list, groupId) => {
      let sorted = groupBy(list, (item) => {
        return [item[groupId]];
      });
      return sorted;
    };
    const groupBy = (arr, f) => {
      let groups = {};
      arr.forEach((o) => {
        let group = JSON.stringify(f(o));
        groups[group] = groups[group] || [];
        groups[group].push(o);
      });
      return Object.keys(groups).map((group) => {
        return groups[group];
      });
    };
    const closeDialog = () => {
      context.emit("update:visible", false);
      context.emit("transferApplicationList", data.transferKeys);
    };
    queryOrganPersonListAsycn();
    return { ...refData, emitCheckList, closeDialog };
  },
});
</script>
<style lang="scss" scoped>
.TransferApplication {
  height: 50vh;
}
</style>
